module.exports = __webpack_public_path__ + "img/bar-empty.2989831a.svg";